import utils from "../utils";
import Splide from '@splidejs/splide';

function initCarousel() {

	let carousels = document.querySelectorAll('.items-carousel');

    if(carousels.length > 0){
        utils.forEach(carousels, function (index, elem) {

			var settings = elem.getAttribute('carousel-settings'),
				slidesNumber = elem.getAttribute('slides-settings'),
				xsNum = 1,
				xsGap = 1,
				smNum = 2,
				smGap = 1,
				mdNum = 3,
				mdGap = 1,
				lgNum = 4,
				lgGap = 2,
				xlNum = 5,
				xlGap = 2,
				navigation = false,
				preview = false;

			if(settings){

				var jsonDataSettings = JSON.parse(settings);

				navigation = jsonDataSettings.carousel_settings_navigation;
				preview = jsonDataSettings.carousel_settings_preview;

				var sideValueXs = '0',
					sideValueSm = '0',
					sideValueMd = '6rem',
					sideValueLg = '10rem',
					sideValueXl = '12rem',
					sideValueXxl = '16rem',
					side = 'right',
					noSide = 'left',
					directionValue = 'ltr';

				if(preview == 'left'){
					side = 'left';
					noSide = 'right';
					directionValue = 'rtl';
				} else if(preview == 'right'){
					side = 'right';
					noSide = 'left';
				} else {
					sideValueXs = '0rem';
					sideValueSm = '0rem';
					sideValueMd = '0rem';
					sideValueLg = '0rem';
					sideValueXl = '0rem';
					sideValueXxl = '0rem';
				}

			}

			if(slidesNumber){

				var jsonDataNumber = JSON.parse(slidesNumber);

				xsNum = jsonDataNumber.carousel_slidesettings_xs_number,
				xsGap = jsonDataNumber.carousel_slidesettings_xs_gap,
				smNum = jsonDataNumber.carousel_slidesettings_sm_number,
				smGap = jsonDataNumber.carousel_slidesettings_sm_gap,
				mdNum = jsonDataNumber.carousel_slidesettings_md_number,
				mdGap = jsonDataNumber.carousel_slidesettings_md_gap,
				lgNum = jsonDataNumber.carousel_slidesettings_lg_number,
				lgGap = jsonDataNumber.carousel_slidesettings_lg_gap,
				xlNum = jsonDataNumber.carousel_slidesettings_xl_number,
				xlGap = jsonDataNumber.carousel_slidesettings_xl_gap;
			}
			
			var carouselSingle = new Splide(elem, { // eslint-disable-line no-unused-vars
				type: 'loop',
				autoplay: true,
				interval: 1300,
				speed: 800,
				perPage: xlNum,
				padding: { [noSide]: 0, [side]: sideValueXxl },
				gap: xlGap + 'rem',
				pagination: false,
				arrows: navigation,
				updateOnMove: true,
				
				perMove: 1,
				rewindByDrag: false,
				rewind: false,
				direction : directionValue,
				arrowPath: "m30.98,29.02l-1.23-1.24,6.91-6.91H0v-1.75h36.65l-6.9-6.91,1.23-1.23,9.02,9.02-9.02,9.02Z",
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav  magic-hover",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
				breakpoints: {
					400: {
						perPage: xsNum,
						gap: xsGap + 'rem',
						padding: { [noSide]: 0, [side]: sideValueXs },
					},
					576: {
						perPage: smNum,
						gap: smGap + 'rem',
						padding: { [noSide]: 0, [side]: sideValueSm },
					},
					768: {
						perPage: mdNum,
						gap: mdGap + 'rem',
						padding: { [noSide]: 0, [side]: sideValueMd },
					},
					992: {
						perPage: lgNum,
						gap: lgGap + 'rem',
						padding: { [noSide]: 0, [side]: sideValueLg },
					},
					1200: {
						perPage: xlNum,
						gap: xlGap + 'rem',
						padding: { [noSide]: 0, [side]: sideValueXl },
					},
				},
			}).mount();
		});
    }

}

export default { initCarousel };
